import { render, staticRenderFns } from "./ViewPortOverlay.vue?vue&type=template&id=7c0fa0a2"
import script from "./ViewPortOverlay.vue?vue&type=script&lang=ts"
export * from "./ViewPortOverlay.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports